'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Box = _interopDefault(require('../box'));
var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('box', _vm._l(_vm.data, function (item, key) {
      return _c('div', {
        key: key,
        staticClass: "accordion cell"
      }, [_c('h3', {
        directives: [{
          name: "tap",
          rawName: "v-tap"
        }],
        class: ['accordion-title', {
          active: key === _vm.value
        }],
        domProps: {
          "innerHTML": _vm._s(item.title)
        },
        on: {
          "click": function click($event) {
            _vm.$emit('input', key === _vm.value ? -1 : key);
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "accordion-body",
        domProps: {
          "innerHTML": _vm._s(item.body)
        }
      })]);
    }), 0);
  },
  staticRenderFns: [],
  name: 'accordion',
  props: {
    data: Array,
    value: Number
  },
  components: {
    Box: Box
  }
});

exports.default = index;
